export enum AuthStep {
  Form = 'form',
  Kyc = 'kyc',
}
